"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = watchUserLogin;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _humps = require("humps");

var _effects = require("redux-saga/effects");

var _utils = require("@dom/utils");

var _user = require("../actions/user");

var _analytics = require("../actions/analytics");

var _auth = require("../actions/auth");

var _types = require("../actions/types");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(watchUserLogin),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(signup),
    _marked3 =
/*#__PURE__*/
_regenerator["default"].mark(login),
    _marked4 =
/*#__PURE__*/
_regenerator["default"].mark(signupWithEmail);

function watchUserLogin() {
  return _regenerator["default"].wrap(function watchUserLogin$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.takeLatest)(_types.REGISTER_ACCOUNT, signup), (0, _effects.takeLatest)(_types.REQUEST_LOGIN, login), (0, _effects.takeLatest)(_types.LOGOUT, logout)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function signup(action) {
  var signedUpUsingFbOrGoogle;
  return _regenerator["default"].wrap(function signup$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          signedUpUsingFbOrGoogle = Boolean(action.credentials.provider);

          if (!signedUpUsingFbOrGoogle) {
            _context2.next = 8;
            break;
          }

          _context2.next = 4;
          return login(action);

        case 4:
          _context2.next = 6;
          return (0, _analytics.onSignupSuccess)(action.credentials.provider);

        case 6:
          _context2.next = 10;
          break;

        case 8:
          _context2.next = 10;
          return signupWithEmail(action);

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var _cookieFactory = (0, _utils.cookieFactory)('TOKEN'),
    createCookie = _cookieFactory.createCookie,
    deleteCookie = _cookieFactory.deleteCookie;

function login(action) {
  var _ref, token, defaultError;

  return _regenerator["default"].wrap(function login$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(authenticate, action);

        case 3:
          _ref = _context3.sent;
          token = _ref.data.token;
          _context3.next = 7;
          return createCookie(token, 3);

        case 7:
          _context3.next = 9;
          return storeInLocalStorage(token);

        case 9:
          _context3.next = 11;
          return (0, _effects.put)((0, _user.initUserInfo)(token));

        case 11:
          _context3.next = 13;
          return (0, _effects.put)((0, _auth.closeAuthModal)());

        case 13:
          _context3.next = 21;
          break;

        case 15:
          _context3.prev = 15;
          _context3.t0 = _context3["catch"](0);
          removeItemsFromLocalStorage();
          defaultError = _context3.t0.response ? _context3.t0.response.data.message : 'There was some error with the server. Please try again!';
          _context3.next = 21;
          return (0, _effects.put)((0, _auth.reportError)(defaultError));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 15]]);
}

function signupWithEmail(action) {
  return _regenerator["default"].wrap(function signupWithEmail$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(authenticate, action);

        case 3:
          _context4.next = 5;
          return (0, _effects.put)((0, _analytics.onSignupSuccess)('email'));

        case 5:
          _context4.next = 7;
          return (0, _effects.put)((0, _auth.closeAuthModal)());

        case 7:
          window.location = _utils.makeUrl.signup.peningVerification;
          _context4.next = 14;
          break;

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 14;
          return (0, _effects.put)((0, _auth.reportError)(_context4.t0.response.data.message));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 10]]);
}

function logout() {
  removeItemsFromLocalStorage();
  deleteCookie('TOKEN');
  window.location = '/';
}

function authenticate(action) {
  var _decideEndpointAndDat = decideEndpointAndData(action),
      endpoint = _decideEndpointAndDat.endpoint,
      data = _decideEndpointAndDat.data;

  return _utils.api.postWithoutToken(endpoint, (0, _humps.decamelizeKeys)(data));
}

function decideEndpointAndData(_ref2) {
  var type = _ref2.type,
      credentials = _ref2.credentials;
  var fromFbOrGoogle = Boolean(credentials.provider);
  var isSignupWithEmail = type.includes('register') && !fromFbOrGoogle;

  if (isSignupWithEmail) {
    return {
      endpoint: _utils.endpoints.auth.signup,
      data: (0, _objectSpread2["default"])({}, credentials)
    };
  }

  var loginDataforEmail = {
    classic: (0, _objectSpread2["default"])({}, credentials)
  };
  var loginorSignupDataforFborGoogle = {
    oauth: (0, _objectSpread2["default"])({}, credentials)
  };
  return {
    endpoint: _utils.endpoints.auth.login,
    data: fromFbOrGoogle ? loginorSignupDataforFborGoogle : loginDataforEmail
  };
} // ----------------------------------------
// HELPERS
// ----------------------------------------


function storeInLocalStorage(token) {
  var _jwt_decode = (0, _jwtDecode["default"])(token),
      roles = _jwt_decode.roles,
      sub = _jwt_decode.sub,
      exp = _jwt_decode.exp;

  var obj = {
    token: token,
    roles: roles,
    id: sub,
    expireToken: exp
  };

  for (var key in obj) {
    localStorage.setItem([key], obj[key]);
  }
}

var removeItemsFromLocalStorage = function removeItemsFromLocalStorage() {
  return localStorage.clear();
};